import { uuid } from '../..'
import type { EventTypeOption } from '../..'

export function createEventType({ production = false }: { production?: boolean }): EventTypeOption {
  return {
    key: uuid(),
    label: '',
    production
  }
}
